import { GuardedComponent } from '../components/guarded-component';
import { WorkOrderReportPaigngPage } from '../features/work-order-report-paging/work-order-report-paging.page';
import { WorkOrderReportPage } from '../features/work-order-report/work-order-report.page';
import { UserPermissionName } from '../models/user-permission-name';

export const WorkorderReportPagingRoute = {
  path: '/workorder-reports-paging',
  name: 'Work Order Reports',
  children: [
    {
      index: true,
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_WORKORDER_REPORTS]} showPermissionError>
          <WorkOrderReportPaigngPage />
        </GuardedComponent>
      ),
    },
  ],
};
